/* bl-track.js (2026-09-20, r2) — pass the page query string through to the brand tracking app on the store's own track subdomain
   (same infrastructure as the other stores: track.<domain> → Vercel proxy → PO track-page EF; the boot page picks the brillilume skin by host). */
(function () {
  var q = window.location.search || '';
  document.getElementById('trk').src = 'https://track.brillilume.com/' + q;
})();
